import React, { useEffect, useState } from 'react'
// import ConfirmDoneIcon from '../../assets/images/ConfirmIconGreen.png';
// import ShareIcon from '../../assets/icons/ShareIcon';
// import DownloadIcon from '../../assets/icons/DownloadIcon';
// import PrintIcon from '../../assets/icons/PrintIcon';
// import CartIcon from '../../assets/icons/CopyIcon';
import html2canvas from 'html2canvas';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CartIcon from 'Ecommerce/template_three/assets/icons/CartIcon';
import PrintIcon from 'Ecommerce/template_three/assets/icons/PrintIcon';
import DownloadIcon from 'Ecommerce/template_three/assets/icons/DownloadIcon';
import ShareIcon from 'Ecommerce/template_three/assets/icons/ShareIcon';
import CircledTick from 'admin/common/icons/sidebar/CircledTick';
import RightArrow from 'admin/common/icons/right-arrow';
import LeftArrow from 'Ecommerce/common/icons/LeftArrow';
import LeftIcon from 'admin/common/icons/sidebar/LeftIcon';
import CopyIcon from 'admin/common/icons/CopyIcon';

export default function ConfirmPage(props) {
    const { t } = useTranslation();
    const [appoinmentconfirm, setappoinmentconfirm] = useState(true);
    const navigate = useNavigate();
    const [showstatus, setShowstatus] = useState(false)
    const [orderdetails, setOrderdetails] = useState({});
    const [finalPage, setFinalpage] = useState(false);
    const [privacyPolicy, setPrivacyPolicy] = useState({first: false, last: false});
    const { lastpagedata, countrylist,shippinglist ,shippingdata,creditpaymentdata, paytime} = props
    const [orderdata , setorderdata] = useState({});
    // console.log(lastpagedata, orderdetails, countrylist,shippinglist,shippingdata,creditpaymentdata, "chekc last page data")
    const handleCopyClick = async (cupyinput) => {
        try {
            await navigator.clipboard.writeText(cupyinput);
            setShowstatus(true)
            setTimeout(() => {
                setShowstatus(false);
            }, 2000);
        } catch (err) {
            console.log(err, "err");
        }
    };

    const formatTime = (timeString) => {
        try {
            const date = new Date(timeString);
            if (!date.getTime()) throw new Error("Invalid date");
    
            return date.toLocaleString("en-GB", { 
                day: "2-digit", 
                month: "2-digit", 
                year: "numeric", 
                hour: "2-digit", 
                minute: "2-digit", 
                second: "2-digit",
                hour12: false 
            }).replace(",", "");
        } catch (error) {
            console.error("Error parsing date, falling back to current time:", error.message);
            const now = new Date();
            return now.toLocaleString("en-GB", { 
                day: "2-digit", 
                month: "2-digit", 
                year: "numeric", 
                hour: "2-digit", 
                minute: "2-digit", 
                second: "2-digit",
                hour12: false 
            }).replace(",", "");
        }
    };


    const downloadPageAsPNG = () => {
        const rootElement = document.getElementById('saveorder');
        html2canvas(rootElement).then((canvas) => {
            const imageURL = canvas.toDataURL('image/png');
            const anchor = document.createElement('a');
            anchor.download = `${orderdetails?.order_no}.png`;
            anchor.href = imageURL;
            anchor.click();
        });
    };
    const handlePrint = () => {
        window.print();
    };
    const setalldata = () => {
        if (lastpagedata?.statusCode === 200) {
            if (countrylist?.length) {
                var shippingcountryname = countrylist.find((item) => item?.value === lastpagedata?.data?.shipping?.country)
                var billingcountryname = countrylist.find((item) => item?.value === lastpagedata?.data?.billing?.country)
            }
            let dataobj = {
                shipping: {},
                billing: {},
                order_no: ""
            }
            let shippingname = [
                lastpagedata?.data?.shipping?.fname ?? '',
                lastpagedata?.data?.shipping?.mname ?? '',
                lastpagedata?.data?.shipping?.lname ?? ''
            ]
            dataobj.shipping.name = shippingname.filter(part => part).join(' ');
            let shippingaddressParts = [
                lastpagedata?.data?.shipping?.address ?? '',
                lastpagedata?.data?.shipping?.city ?? '',
                lastpagedata?.data?.shipping?.state ?? '',
                shippingcountryname?.label ?? '',
                lastpagedata?.data?.shipping?.zipcode ?? ''
            ];

            dataobj.shipping.address = shippingaddressParts.filter(part => part).join(', ');
            dataobj.shipping.contact = lastpagedata?.data?.shipping?.contacts?.length ? lastpagedata?.data?.shipping?.contacts[0]?.number : ""
            dataobj.shipping.email = lastpagedata?.data?.shipping?.emails?.length ? lastpagedata?.data?.shipping?.emails[0] : ""
            dataobj.shipping.taxId = lastpagedata?.data?.shipping?.taxId ? lastpagedata?.data?.shipping?.taxId : ""
            let billingname = [
                lastpagedata?.data?.billing?.fname ?? '',
                lastpagedata?.data?.billing?.mname ?? '',
                lastpagedata?.data?.billing?.lname ?? ''
            ]
            dataobj.billing.name = billingname.filter(part => part).join(' ');
            let addressParts = [
                lastpagedata?.data?.billing?.address ?? '',
                lastpagedata?.data?.billing?.city ?? '',
                lastpagedata?.data?.billing?.state ?? '',
                billingcountryname?.label ?? '',
                lastpagedata?.data?.billing?.zipcode ?? ''
            ];

            dataobj.billing.address = addressParts.filter(part => part).join(', ');
            dataobj.billing.contact = lastpagedata?.data?.billing?.contacts?.length ? lastpagedata?.data?.billing?.contacts[0]?.number : ""
            dataobj.billing.email = lastpagedata?.data?.billing?.emails?.length ? lastpagedata?.data?.billing?.emails[0] : ""
            dataobj.billing.taxId = lastpagedata?.data?.billing?.taxId ? lastpagedata?.data?.billing?.taxId : ""
            dataobj.order_no = lastpagedata?.data?.order_no
            dataobj.tax_id = lastpagedata?.data?.tax_id
            setOrderdetails(dataobj)
        }
    }
    useEffect(() => {
        // console.log(lastpagedata?.statusCode, "HHHHHHHHHHHHHHHHHHHHHHHh", lastpagedata);

        if (lastpagedata?.statusCode === 200) {
            setalldata()
            setorderdata(lastpagedata?.data || {})
        }
        // eslint-disable-next-line
        // console.log(orderdetails, "check orders details")
    }, [lastpagedata?.statusCode])

    const handleFinal = () =>{
        if(privacyPolicy?.first){
            setFinalpage(true);
        }
    }

    const handleContinueShopping = () => {
        if(privacyPolicy?.last){
            navigate('/collection')
        }
    }

    const orderItemList = [
        {img : 'alf', title: 'C-CLASSIC PAVE BAND', subtitle:'SOLITAIRE COLLECTION', metal: 'Silver', size: '45', price: '฿ 31,800.00', qty:1},
        {img : 'alf', title: 'C-CLASSIC PAVE BAND', subtitle:'SOLITAIRE COLLECTION', metal: 'Silver', size: '45', price: '฿ 31,800.00', qty:1}
    ]
  return (
    <>
    { finalPage ? 
     <div className='ecom-confirmPurchasePage-main' id="saveorder">
     <div className='ecom-confirmPurchasePage-main-headerBox'>
     <span className='ecom-confirmPurchasePage-main-headerBox-doneIconBox'>
             <CircledTick type="curledTick"/>
         </span>
         <h3 className='ecom-confirmPurchasePage-main-headerBox-thankYouText'>{t("Thank you for your purchase")}!</h3>
        <h4 className='ecom-confirmPurchasePage-main-headerBox-subtext'><span>{t("ORDER NO.")}: #{orderdetails?.order_no}</span> <span onClick={() => handleCopyClick(orderdetails?.order_no)}><CopyIcon width="19px" height="19px"/></span></h4>
        <span className='text-center'>{showstatus ? t("Copy Successfully") : ""} </span>
     </div>
     <div className='ecom-confirmPurchasePage-main-containerBox'>
         {/* <div className='ecom-confirmPurchasePage-main-containerBox-getDocsIconBox'>
             <span className='ecom-confirmPurchasePage-main-containerBox-getDocsIconBox-Iconspan'><ShareIcon /></span>
             <span className='ecom-confirmPurchasePage-main-containerBox-getDocsIconBox-Iconspan' onClick={() => downloadPageAsPNG()}><DownloadIcon /></span>
             <span className='ecom-confirmPurchasePage-main-containerBox-getDocsIconBox-Iconspan' onClick={() => handlePrint()}><PrintIcon /></span>
         </div> */}
         {/* <div className='ecom-confirmPurchasePage-main-containerBox-middleContentBox'>
             <div className='ecom-confirmPurchasePage-main-containerBox-middleContentBox-purchaseIdBox'><span className='idShows'>{t("ID")} : #{orderdetails?.order_no}</span> <span onClick={() => handleCopyClick(orderdetails?.order_no)}><CartIcon widt={'19px'} height={'19px'} /> </span></div>
             <span className='text-center'>{showstatus ? t("Copy Successfully") : ""} </span>
             <div className='ecom-confirmPurchasePage-main-containerBox-middleContentBox-thanksParaBox'>{("Thank you for your order, you have successfully placed your order, you can track your order status")} <span>{t("here")}</span>,{t(" Below are related products that goes with what you just purchased")}</div>
         </div> */}
         <div className='ecom-confirmPurchasePage-main-containerBox-productwrapper'>
            <div className='ecom-confirmPurchasePage-main-containerBox-productwrapper-heading'>{t("You have ordered")} {shippinglist?.length} {t("products")}</div>
            <div className='ecom-confirmPurchasePage-main-containerBox-productwrapper-list'>
                {shippinglist?.length ? shippinglist.map((item, index)=>{
                    return(
                        <div className='item_container' key={index}>
                            <div className='item_container_image'><img src={item?.main_image} alt='prd'/></div>
                            <div className='item_container_content'>
                                <div className='item_container_content-left'>
                                    <span>{item?.name}</span>
                                    <span>{item?.SKU}</span>
                                    <span className='graytext'>{item?.Metal}</span>
                                    <span className='sizetext'>{t("Size")}: {item?.Size}</span>
                                    <span className='price'>{item?.price}</span>
                                </div>
                                <div className='item_container_content-right'>X{item?.qty}</div>
                            </div>
                        </div>
                    )
                }) : null}
            </div>
            <div className='ecom-confirmPurchasePage-main-containerBox-productwrapper-price'>
                <div className='item'><span>{t("Items")}</span><span>{shippinglist?.length ? shippinglist?.reduce((acc,item)=>{return acc += item.qty},0) : '-'}</span></div>
                <div className='item'><span>{t("Sub Total")}</span><span>{`${shippingdata?.CURRENCY} ${shippinglist?.reduce((acc, product) => acc + product?.UnFormatPrice*product?.qty, 0)}`}</span></div>
                <div className='item'><span>{t("Shipping")}</span><span>{`${shippingdata?.CURRENCY} ${shippingdata?.shipprice}`}</span></div>
                {/* <div className='item'><span>{t("Vat")} 7%</span><span>{`${shippingdata?.CURRENCY} ${shippingdata?.shipprice}`}</span></div> */}
            </div>
            <div className='ecom-confirmPurchasePage-main-containerBox-productwrapper-price border-0'>
            <div className='item'><span>{t("Total")}</span><span>{`${shippingdata?.CURRENCY} ${shippinglist?.reduce((acc, product) => acc + product?.UnFormatPrice*product?.qty, 0)+shippingdata?.shipprice}`}</span></div>
            </div>
         </div>
         <div className='ecom-confirmPurchasePage-main-containerBox-allshippingAddrShow'>
             <div className="ecom-addressShowBox ecom-confirmPurchasePage-main-containerBox-allshippingAddrShow-singleShippAddr">
                 <div className="ecom-addressShowBox-headerBox">
                     <h2 className='shippingaddrHeader'>{t("Shipping Addresses")}</h2>
                 </div>
                 <div className='addressdivonconfirmpage'>
                 <h3 className="ecom-addressShowBox-AddrparaBox">
                     {orderdetails?.shipping?.name}
                 </h3>
                 <p className="ecom-addressShowBox-AddrparaBox w-100">
                     {orderdetails?.shipping?.address}
                 </p>
                 <p className="ecom-addressShowBox-phonePara">
                     {orderdetails?.shipping?.contact}
                 </p>
                 <p className="ecom-addressShowBox-phonePara">
                     {orderdetails?.shipping?.email}
                 </p>
                 </div>
             </div>
             <div className="ecom-addressShowBox ecom-confirmPurchasePage-main-containerBox-allshippingAddrShow-singleShippAddr d-flex flex-row justify-content-between">
                 <div className="ecom-addressShowBox-headerBox w-auto">
                     <h2 className='shippingaddrHeader'>{t("Billing Addresses")}</h2>
                 </div>
                 <div className='addressdivonconfirmpage'>
                 <h3 className="ecom-addressShowBox-AddrparaBox">
                     {orderdetails?.billing?.name}
                 </h3>
                 <p className="ecom-addressShowBox-AddrparaBox w-100">
                     {orderdetails?.billing?.address}
                 </p>
                 <p className="ecom-addressShowBox-AddrparaBox w-100">
                 {t("Tax ID")}:
                 <span>{orderdetails?.tax_id}</span>
                 </p>
                 <p className="ecom-addressShowBox-phonePara">
                     {orderdetails?.billing?.contact}
                 </p>
                 <p className="ecom-addressShowBox-phonePara">
                     {orderdetails?.billing?.email}
                 </p>
                 </div>
             </div>
         </div>
     </div>
     <div className="ecom-darkthemed-checkbox ecom-checkbox-wrapper">
                                                    <input
                                                    type="checkbox"
                                                    id="privacy-policy-final"
                                                    onChange={() =>  setPrivacyPolicy((state)=>({...state, last: !privacyPolicy?.last}))}
                                                    checked={privacyPolicy?.last ? true : false}
                                                    />
                                                    <label htmlFor="privacy-policy-final" className="ecom-darkthemed-checkbox-label">
                                                    </label>
                                                    <span className={`mobilefilter-inner-wrapper-content-filterdata-holder-label`}>{t("I accept the")}{" "}<span className="text-decoration-underline">{t("Privacy Policy")}</span>{" "}{t("and")}{" "}<span className="text-decoration-underline">{t("Terms and conditions")}</span>.</span>
                                                </div>
     {appoinmentconfirm ?
         <div className='ecom-confirmPurchasePage-main-footerBox d-flex gap-4 justify-content-center'>
             <Link to="/account/purchasehistory" className='btnwithborder text-decoration-none'>{t("View Purchase History")}</Link>
             <Link to={"/collection"} className='btnbold text-decoration-none'><span>{t("Continue Shopping")}</span></Link>
         </div> : ""}
     </div>
     : 
     <div className='ecom-shipping_stepthree'>
        <div className='ecom-shipping_stepthree-head'>
            <span><CircledTick/></span><span>{t("Payment Successful!")}</span>
        </div>
        <div className='ecom-shipping_stepthree-content'>
            <div className='ecom-shipping_stepthree-content-subhead'><span>{t("Payment Details")}</span></div>
            <div className='ecom-shipping_stepthree-content-metadata'>
                <div className='ecom-shipping_stepthree-content-metadata-item'>
                    <div className='ecom-shipping_stepthree-content-metadata-title'>{t("Payment to")}</div>
                    <div className='ecom-shipping_stepthree-content-metadata-data tmpthree'>
                        <div><img  src={orderdata?.payment_to?.location_logo} alt='NA' /></div>
                        <div className='ecom-shipping_stepthree-content-metadata-data-inner'>
                            <span>{orderdata?.payment_to?.name || '-'}</span>
                            <span>{orderdata?.payment_to?.address || '-'}</span>
                        </div>
                    </div>
                </div>
                <div className='ecom-shipping_stepthree-content-metadata-item'>
                    <div className='ecom-shipping_stepthree-content-metadata-title'>{t("Ref Number")}</div>
                    <div className='ecom-shipping_stepthree-content-metadata-data'>
                    {orderdata?.order_no  || '-'}
                    </div>
                </div>
                <div className='ecom-shipping_stepthree-content-metadata-item'>
                    <div className='ecom-shipping_stepthree-content-metadata-title'>{t("Payment Method")}</div>
                    <div className='ecom-shipping_stepthree-content-metadata-data'>
                    {orderdata?.payment_method || '-'}
                    </div>
                </div>
                <div className='ecom-shipping_stepthree-content-metadata-item'>
                    <div className='ecom-shipping_stepthree-content-metadata-title'>{t("Payment Status")}</div>
                    <div className='ecom-shipping_stepthree-content-metadata-data success'>
                        {orderdata?.payment_status || '-'}
                    </div>
                </div>
                <div className='ecom-shipping_stepthree-content-metadata-item'>
                    <div className='ecom-shipping_stepthree-content-metadata-title'>{t("Payment Time")}</div>
                    <div className='ecom-shipping_stepthree-content-metadata-data'>
                        { formatTime(orderdata?.payment_time) || '-' }
                    </div>
                </div>
                <div className='ecom-shipping_stepthree-content-metadata-item'>
                    <div className='ecom-shipping_stepthree-content-metadata-title'>{t("Customer Name")}</div>
                    <div className='ecom-shipping_stepthree-content-metadata-data'>
                    {orderdata?.customer_name  || '-'}
                    </div>
                </div>
                <div className='ecom-shipping_stepthree-content-metadata-item'>
                    <div className='ecom-shipping_stepthree-content-metadata-title'>{t("Total Payment")}</div>
                    <div className='ecom-shipping_stepthree-content-metadata-data'>
                    {orderdata?.total_payment}
                   
                    </div>
                </div>
            </div>
            <div className='ecom-shipping_stepthree-content-addresswrapper'>
                <div className='ecom-shipping_stepthree-content-addresswrapper-title'>{t("Billing Address")}</div>
                <div className='ecom-shipping_stepthree-content-addresswrapper-list'>
                    <div className='ecom-shipping_stepthree-content-addresswrapper-list-item'>{orderdetails?.billing?.name}</div>
                    <div className='ecom-shipping_stepthree-content-addresswrapper-list-item'>{orderdetails?.billing?.address}</div>
                    <div className='ecom-shipping_stepthree-content-addresswrapper-list-item'>{t("Tax ID No")} : {orderdetails?.billing?.taxId}</div>
                    <div className='ecom-shipping_stepthree-content-addresswrapper-list-item'>{t("Tel")} : {orderdetails?.billing?.contact}</div>
                    <div className='ecom-shipping_stepthree-content-addresswrapper-list-item'>{orderdetails?.billing?.email}</div>
                </div>
            </div>
            <div className='ecom-shipping_stepthree-content-addresswrapper'>
                <div>{t("Shipping Address")}</div>
                <div className='ecom-shipping_stepthree-content-addresswrapper-list'>
                    <div className='ecom-shipping_stepthree-content-addresswrapper-list-item'>{orderdetails?.shipping?.name}</div>
                    <div className='ecom-shipping_stepthree-content-addresswrapper-list-item'>{orderdetails?.shipping?.address}</div>
                    <div className='ecom-shipping_stepthree-content-addresswrapper-list-item'>{t("Tax ID No")} : {orderdetails?.shipping?.taxId}</div>
                    <div className='ecom-shipping_stepthree-content-addresswrapper-list-item'> {t("Tel")} : {orderdetails?.shipping?.contact}</div>
                    <div className='ecom-shipping_stepthree-content-addresswrapper-list-item'>{orderdetails?.shipping?.email}</div>
                </div>
            </div>
        </div>
        <div className='ecom-shipping_stepthree-bottom'>
        <div className="ecom-darkthemed-checkbox ecom-checkbox-wrapper">
                                                    <input
                                                    type="checkbox"
                                                    id="privacy-policy"
                                                    onChange={() =>  setPrivacyPolicy((state)=>({...state, first: !privacyPolicy?.first}))}
                                                    checked={privacyPolicy?.first ? true : false}
                                                    />
                                                    <label htmlFor="privacy-policy" className="ecom-darkthemed-checkbox-label">
                                                    </label>
                                                    <span className={`mobilefilter-inner-wrapper-content-filterdata-holder-label`}>{t("I accept the")}{" "}<span className="text-decoration-underline">{t("Privacy Policy")}</span>{" "}{t("and")}{" "}<span className="text-decoration-underline">{t("Terms and conditions")}</span>.</span>
                                                </div>
            <div className='ecom-shipping_stepthree-bottom-navigator'>
                <div className='ecom-shipping_stepthree-bottom-navigator-back' onClick={()=>setFinalpage(false)}><LeftIcon/> <span>{t("Return to Cart")}</span></div>
                <div className='btnbold' onClick={()=>handleFinal()}>
                    <span>{t("Continue")}</span>
                </div>
            </div>
        </div>
     </div>
    }
   
    </>
  )
}
